import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { MeetingsMetadataSchema } from '../base/meetingMetadata.js';
export const InitializeMultipartVideoUploadApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    body: z.object({
        contentType: z.string(),
        description: z.string().optional(),
        filename: z.string(),
        metadata: MeetingsMetadataSchema.optional(),
        notes: z.string().optional(),
        /** Will this video be stitched with one or more other videos? */
        requiresStitching: z.coerce.boolean().optional(),
        startTime: z.string().datetime(),
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema.pick({ requestActor: true }),
    response: z.object({
        expiration: z.string().datetime(),
        uploadId: z.string(),
    }),
};
export const InitializeMultipartVideoUploadRequestSchema = InitializeMultipartVideoUploadApiSchema.params
    .merge(InitializeMultipartVideoUploadApiSchema.headers)
    .merge(InitializeMultipartVideoUploadApiSchema.body);
